import type { Plugin } from '@nuxt/types';
import * as pages from '@/constants/pages';

/**
 * @description
 * Object containing:
 * - all pages in pages constants.
 * - all pages generated by "generate-pages" script.
 * @see {@link pages} */
const pagesPlugin: Plugin = (_, inject) => {
  inject('pages', pages);
};

export default pagesPlugin;
